export default __webpack_public_path__ + "static/media/html5.74577817.svg";